import React from "react";
import { useTranslation } from "react-i18next";
import { IFormValues } from "../types";
import { FormAutocomplete } from "../../../components/fields";

const  DisableFormAutocomplete = (props: {name: any, label: string}) => {
    const { t } = useTranslation('booking');
    return (
        <FormAutocomplete<IFormValues>
            name={props.name}
            label={t(`${props.label}`)}
            options={[]}
            multiple={true}
            readOnly
            textFieldProps={{
                InputLabelProps: {
                    shrink: true
                }
            }}
            disabled={true}
        />
    )
}

export default DisableFormAutocomplete;
